import { useMemo } from 'react';
import { TableRow, TableCell, Typography } from '@occc-app/design-system';
import { Site_System_Connection_Action } from '@occc/graphql';

import { DateTimeFormatTZ, formatDateTimeTZ, parseDate } from '../../../../../lib/date';
import { formatDurationTime } from '../location-connection-history.utils';

type LocationActivityProps = {
  connectedAt: string;
  disconnectedAt?: string | null;
  connectionDuration?: number | null;
  sent?: number | null;
  received?: number | null;
  disconnectReason?: Site_System_Connection_Action | null;
  timezone: string;
};

export const ConnectionHistoryItem = ({
  connectedAt,
  disconnectedAt,
  connectionDuration,
  sent,
  received,
  disconnectReason,
  timezone,
}: LocationActivityProps) => {
  const { date, time, timeZone } = useMemo(() => {
    const date = formatDateTimeTZ(parseDate(connectedAt), timezone, DateTimeFormatTZ.DateWithSlash);
    const time = formatDateTimeTZ(parseDate(connectedAt), timezone, DateTimeFormatTZ.Time24h);
    const timeZone = formatDateTimeTZ(
      parseDate(connectedAt),
      timezone,
      DateTimeFormatTZ.ShortTimeZone,
    );

    return { date, time, timeZone };
  }, [connectedAt, timezone]);

  return (
    <TableRow>
      <TableCell>
        <Typography component='span' variant='body2'>
          {date}&nbsp;
        </Typography>
        <Typography component='span' variant='body2' fontWeight={600}>
          {time}&nbsp;
        </Typography>
        <Typography component='span' variant='body2'>
          {timeZone}
        </Typography>
      </TableCell>
      <TableCell>{disconnectedAt}</TableCell>
      <TableCell>{formatDurationTime(connectionDuration)}</TableCell>
      <TableCell>
        {sent ?? 0}/{received ?? 0}
      </TableCell>
      <TableCell>{disconnectReason}</TableCell>
    </TableRow>
  );
};
